export const TUTOR_ME_URL = 'https://tutorme.com/'
export const TUTOR_ME_APP_URL = 'https://app.tutorme.com/'
